
export const REQUEST_DELETEVIDEONOTE= 'REQUEST_DELETEVIDEONOTE';
export const DELETEVIDEONOTE_RECEIVED = 'DELETEVIDEONOTE_RECEIVED';